import type { SWRResponse } from 'swr'
import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { UseUserSettingsInterface } from '../user-settings/types/user-settings-interface'

export function useUserSettings(): SWRResponse<UseUserSettingsInterface, unknown, unknown> {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    UseUserSettingsInterface
  >({
    method: RequestMethodsEnum.get,
  })
  return useSWR<UseUserSettingsInterface>(() => {
    return '/api/settings/profile'
  }, fetcher)
}
